import * as React from 'react';
import classNames from 'classnames';
import {Flex, Text, Currency, Tags, Link} from 'components/UIKit';
import {ListingMetrics} from '../ListingMetrics';
import {ListingShop} from '../../types';
import styles from './ListingSummary.scss';

export interface ListingSummaryProps {
  linkTo?: boolean;
  listing: ListingShop;
  subHeader?: string;
  hideBorder?: boolean;
  hideTags?: boolean;
  hidePrice?: boolean;
  showMetrics?: boolean;
  renderFooter?: () => React.ReactNode;
  renderSubHeader?: () => React.ReactNode;
  renderTopButton?: () => React.ReactNode;
}

function NOOP() {
  return null;
}

export function ListingSummary({
  linkTo = false,
  listing,
  hideBorder = false,
  hidePrice = false,
  showMetrics = false,
  hideTags = false,
  renderFooter = NOOP,
  renderSubHeader = NOOP,
  renderTopButton = NOOP,
}: ListingSummaryProps) {
  return (
    <Flex
      className={classNames(styles.Container, {
        [styles.Metrics]: showMetrics,
        [styles.HideBorder]: hideBorder,
      })}
      direction="column"
    >
      <Flex justifyContent="space-between" alignItems="start">
        <Flex alignItems="center" style={{overflow: 'hidden'}}>
          {linkTo ? (
            <Link
              ellipsis
              type="h3"
              url={listing.shopPath}
              text={listing.title}
              className={styles.Title}
              resetMargin={false}
            />
          ) : (
            <Text ellipsis type="h3" text={listing.title} className={styles.Title} />
          )}
          {renderSubHeader()}
        </Flex>
        {renderTopButton()}
      </Flex>
      <Flex className={styles.Inner} direction="column">
        {!hidePrice && (
          <Currency
            emphasis
            display="h3"
            style={{marginBottom: '14px'}}
            value={listing.salePrice}
            condensed
          />
        )}
        {!hideTags && <Tags tags={listing.shortTags} className={styles.Tags} />}
        {showMetrics && (
          <ListingMetrics
            currencyDisplay="bold"
            condensed
            metrics={listing.condensedMetrics}
            className={styles.Metrics}
          />
        )}
        {renderFooter()}
      </Flex>
    </Flex>
  );
}

export default ListingSummary;
